<div class="container-fluid" id="container-wrapper" style="background-color: white;" *ngIf="userType=='Admin'">

    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800">Leads Upload</h1>
        <button (click)="exportLeadFormat()" class="btn btn-sm btn-primary">Export Lead Format</button>
    </div>

    <div style="margin: auto; padding: 20px; text-align: center; margin-top: 10px; margin-bottom: 10px; background-color: #f8f9fa; border-radius: 5px; border: 1px solid #dee2e6;">

        <div class="row">
            <div class="col-md-6">
                <input type="file" class="form-control" (change)="incomingfile($event)" placeholder="Upload file" accept=".xlsx">
            </div>
            <div class="col-md-6">
                <button type="button" class="btn btn-primary btn-block" (click)="Upload()">Upload</button>
            </div>
        </div>

        <hr>
        <div class="row">
            <div class="col-md-6">
                <button type="button" class="btn btn-danger btn-block" (click)="AssignAssociate()">Assign Associate</button>
            </div>
            <div class="col-md-6">
                <button type="button" class="btn btn-danger btn-block" (click)="Update()">Update</button>
            </div>
        </div>
    </div>

    <div style="overflow-x: auto; margin-top: 20px;">
        <table class="table table-bordered ">
            <thead style="background-color: rgb(10, 10, 80);color: rgb(243, 245, 247);font-size: smaller;">
                <tr>
                    <th style="width: 35px;">SN</th>
                    <th style="width: 80px;">Date</th>
                    <th>Name</th>
                    <th>Mobile No</th>
                    <th>Alternate No</th>
                    <th>E-Mail</th>
                    <th>Address</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Channel Name</th>
                    <th>Source</th>
                    <th>Campaign Name</th>
                    <th>Medium</th>
                    <th>Assigned To</th>
                </tr>
            </thead>
            <tbody style="max-height: 300px!important;overflow-y: scroll;overflow-x: hidden;" id="myTable">
                <tr *ngFor="let item of tblLeads;let counter=index;">
                    <td style="width: 35px;">{{counter+1}}</td>
                    <td style="width: 80px;">{{item.leadDate}}</td>
                    <td>{{item.studentName}}</td>
                    <td>{{item.mobileNo}}</td>
                    <td>{{item.alternateNo}}</td>
                    <td>{{item.emailId}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.cityName}}</td>
                    <td>{{item.stateName}}</td>
                    <td>{{item.channelName}}</td>
                    <td>{{item.source}}</td>
                    <td>{{item.leadCampaignName}}</td>
                    <td>{{item.leadMedium}}</td>
                    <td>{{item.assignToCounsellor}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>